import { defineCustomElement } from '@tyler-components-web/core';
import { DatepickerComponent } from './datepicker';
export * from './datepicker';
export * from './datepicker-adapter';
export * from './datepicker-component-delegate';
export * from './datepicker-constants';
export * from './datepicker-foundation';
export function defineDatepickerComponent() {
    defineCustomElement(DatepickerComponent);
}
